import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AppStart() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user?.role === "business") return <Navigate to="/maestro?tab=hoy" replace />;
  if (user?.role === "customer") return <Navigate to="/mis-maestros" replace />;
  if (user?.role === "super_admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/explorar" replace />;
}
